import { render, staticRenderFns } from "./OrderAppBar.vue?vue&type=template&id=010b86f4&scoped=true&"
import script from "./OrderAppBar.vue?vue&type=script&lang=js&"
export * from "./OrderAppBar.vue?vue&type=script&lang=js&"
import style0 from "./OrderAppBar.vue?vue&type=style&index=0&id=010b86f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010b86f4",
  null
  
)

export default component.exports